module.exports = __webpack_public_path__ + "media/images/star-selected-fe4b09f01317109eab0a27e75dabc496.svg";